import React from "react";

import ActivityJobTrigger from "../../JobTrigger/ActivityJobTrigger";
import StateOrActivityChangeLogic from "./StateOrActivityChangeLogic";
import GatewayChangeLogic from "./GatewayChangeLogic";
import { useParams } from "react-router-dom";

const ActivityJobs = ({ allStatesActivityObj, activityData, setActivityData, allJobs }) => {
  const { smId, activityId } = useParams();

  const settingPreActivityData = (data) => {
    setActivityData({ ...activityData, pre_activity_job: data });
  };

  const settingPreSubmission = (data) => {
    setActivityData({ ...activityData, pre_submission: data });
  };

  const settingStateChangeLogic = (data) => {
    setActivityData({ ...activityData, state_change_logic: data });
  };

  const settingActivityChangeLogic = (data) => {
    setActivityData({ ...activityData, activity_change_logic: data });
  };

  const setJobTriggerFormula = (data) => {
    setActivityData({ ...activityData, jobs_trigger_formula: data });
  };

  const settingJobTriggerData = (data) => {
    setActivityData({ ...activityData, jobs_trigger: data });
  };
  console.log("activityData", activityData);
  return (
    <div className="sm_inner_left" style={{ height: "calc(100vh - 136px)" }}>
      <div className="activity_job_trigger">
        <ActivityJobTrigger
          jobTriggerData={activityData.pre_activity_job || []}
          setJobTriggerData={settingPreActivityData}
          stateid={smId}
          actId={activityId}
          allJobs={allJobs.pre_activity || []}
          pageType="statemachine"
          jobType="pre"
        />
        <ActivityJobTrigger
          jobTriggerData={activityData.pre_submission || []}
          setJobTriggerData={settingPreSubmission}
          stateid={smId}
          actId={activityId}
          allJobs={allJobs.pre_submission || []}
          pageType="statemachine"
          jobType="pre_submission"
        />
        <StateOrActivityChangeLogic
          logic={activityData.state_change_logic || []}
          setLogic={settingStateChangeLogic}
          selectionObj={allStatesActivityObj.states}
          type="state"
        />
        <GatewayChangeLogic
          logic={activityData?.gateway_change_logic || []}
          setLogic={(newLogic) => {
            setActivityData({
              ...activityData,
              gateway_change_logic: newLogic
            });
          }}
          selectionObj={allStatesActivityObj.gateways}
        />
        <ActivityJobTrigger
          jobTriggerFormula={activityData.jobs_trigger_formula || ""}
          setJobTriggerFormula={setJobTriggerFormula}
          jobTriggerData={activityData.jobs_trigger || []}
          setJobTriggerData={settingJobTriggerData}
          stateid={smId}
          allJobs={allJobs.post_activity || []}
          actId={activityId}
          pageType="statemachine"
          jobType="post"
        />
        <StateOrActivityChangeLogic
          logic={activityData.activity_change_logic || []}
          setLogic={settingActivityChangeLogic}
          selectionObj={allStatesActivityObj.activities}
          type="activity"
        />
      </div>
    </div>
  );
};

export default ActivityJobs;
